<template>
  <div>
    <offcanvas-nav></offcanvas-nav>
    <router-view />
  </div>
</template>

<script>
import OffcanvasNav from '@/components/app/OffcanvasNav.vue';
export default {
  components: { OffcanvasNav },
  computed: {
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {
    error(fbError = false) {
      this.$toast(fbError || 'Что-то пошло не так', {
        title: 'Ошибка',
        variant: 'warning'
      });
    }
  }
};
</script>

<style></style>
